module.exports = __webpack_public_path__ + "static/media/icon_service_06_pc.3f33ea98.webp";